// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/rspack-vue-loader/dist/stylePostLoader.js!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./InvitationLinksApp.vue?vue&type=style&index=0&id=5a512b0d&scoped=true&lang=css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("4e2998e3", content, true, {});